import { ErrorCodes } from './errorCodes';

export class ClientError {
    constructor(public code: ErrorCodes, public message: string) { }
}